define(["require", "exports", "./resize", "./algebra"], function (require, exports, resize_1, algebra_1) {
    "use strict";
    var _a;
    exports.__esModule = true;
    var sns = 'http://www.w3.org/2000/svg';
    var xns = 'http://www.w3.org/1999/xlink';
    var CornerIndex;
    (function (CornerIndex) {
        CornerIndex[CornerIndex["topLeft"] = 0] = "topLeft";
        CornerIndex[CornerIndex["bottomLeft"] = 1] = "bottomLeft";
        CornerIndex[CornerIndex["bottomRight"] = 2] = "bottomRight";
        CornerIndex[CornerIndex["topRight"] = 3] = "topRight";
    })(CornerIndex || (CornerIndex = {}));
    var indexToHandle = (_a = {},
        _a[CornerIndex.topLeft] = '#topLeftCorner',
        _a[CornerIndex.bottomLeft] = '#bottomLeftCorner',
        _a[CornerIndex.bottomRight] = '#bottomRightCorner',
        _a[CornerIndex.topRight] = '#topRightCorner',
        _a);
    function markBoxCorners(svg) {
        var $box = svg.find('#window-box');
        var $g = $box.parent();
        var box = $box[0];
        var pointCount = box.points.numberOfItems;
        if ($g.find('.point-handle').length === 4) {
            return;
        }
        for (var i = 0; i < pointCount; i++) {
            var point = box.points.getItem(i);
            var corner = document.createElementNS(sns, 'use');
            corner.setAttributeNS(xns, 'href', indexToHandle[i]);
            corner.setAttribute('class', 'point-handle');
            corner.setAttribute('data-index', "" + i);
            corner.x.baseVal.value = point.x;
            corner.y.baseVal.value = point.y;
            $g.append(corner);
        }
    }
    exports.markBoxCorners = markBoxCorners;
    function syncSizeSegments(svg) {
        var box = svg.find("#window-box")[0];
        var widthMark = svg.find('#width-mark')[0];
        var heightMark = svg.find('#height-mark')[0];
        var pointCount = box.points.numberOfItems;
        for (var i = 0; i < pointCount; i++) {
            var point = box.points.getItem(i);
            var cornerIndex = i;
            switch (cornerIndex) {
                case CornerIndex.topLeft:
                    widthMark.x1.baseVal.value = point.x;
                    widthMark.y1.baseVal.value = point.y;
                    heightMark.x1.baseVal.value = point.x;
                    heightMark.y1.baseVal.value = point.y;
                    break;
                case CornerIndex.topRight:
                    widthMark.x2.baseVal.value = point.x;
                    widthMark.y2.baseVal.value = point.y;
                    break;
                case CornerIndex.bottomLeft:
                    heightMark.x2.baseVal.value = point.x;
                    heightMark.y2.baseVal.value = point.y;
                    break;
            }
        }
    }
    exports.syncSizeSegments = syncSizeSegments;
    function makeBoxResizable(svg, handler) {
        var handles = svg.find('.point-handle');
        if (!handles.length) {
            throw new Error('colud not find box corners');
        }
        resize_1.resizable($('.point-handle'), handler);
    }
    exports.makeBoxResizable = makeBoxResizable;
    function moveBoxCorner(box, corner, to) {
        var index = parseInt($(corner).data('index'));
        if (!isNaN(to.x)) {
            corner.x.baseVal.value = to.x;
        }
        if (!isNaN(to.y)) {
            corner.y.baseVal.value = to.y;
        }
        var boxPoint = box.points.getItem(index);
        if (!isNaN(to.x)) {
            boxPoint.x = to.x;
        }
        if (!isNaN(to.y)) {
            boxPoint.y = to.y;
        }
    }
    exports.moveBoxCorner = moveBoxCorner;
    function getCorner(index, $container) {
        var sel = ".point-handle[data-index=\"" + index + "\"]";
        return ($container ? $container.find(sel) : $(sel))[0];
    }
    function repositionRectangularBox($svg, box, corner, to) {
        var index = parseInt($(corner).data('index'));
        switch (index) {
            case CornerIndex.topLeft:
                moveBoxCorner(box, getCorner(CornerIndex.bottomLeft, $svg), { x: to.x, y: NaN });
                moveBoxCorner(box, getCorner(CornerIndex.topRight, $svg), { x: NaN, y: to.y });
                break;
            case CornerIndex.topRight:
                moveBoxCorner(box, getCorner(CornerIndex.bottomRight, $svg), { x: to.x, y: NaN });
                moveBoxCorner(box, getCorner(CornerIndex.topLeft, $svg), { x: NaN, y: to.y });
                break;
            case CornerIndex.bottomLeft:
                moveBoxCorner(box, getCorner(CornerIndex.topLeft, $svg), { x: to.x, y: NaN });
                moveBoxCorner(box, getCorner(CornerIndex.bottomRight, $svg), { x: NaN, y: to.y });
                break;
            case CornerIndex.bottomRight:
                moveBoxCorner(box, getCorner(CornerIndex.topRight, $svg), { x: to.x, y: NaN });
                moveBoxCorner(box, getCorner(CornerIndex.bottomLeft, $svg), { x: NaN, y: to.y });
                break;
        }
        moveBoxCorner(box, corner, to);
    }
    function getBoxEdge(box, c1, c2) {
        return algebra_1.getLine(box.points.getItem(c1), box.points.getItem(c2));
    }
    function shiftBoxEdges($svg, box, corner, to) {
        var _a = box.points.getItem(corner), x = _a.x, y = _a.y;
        var dx = to.x - x;
        var dy = to.y - y;
        var offset = { x: dx, y: dy };
        var leftEdge = getBoxEdge(box, (corner + 1) % 4, corner);
        var rightEdge = getBoxEdge(box, corner, (corner + 3) % 4);
        var newLeft = algebra_1.shift(leftEdge, offset);
        var newRight = algebra_1.shift(rightEdge, offset);
        var crossCorner = (corner + 2) % 4;
        var crossRight = getBoxEdge(box, crossCorner, (crossCorner + 3) % 4);
        var crossLeft = getBoxEdge(box, crossCorner, (crossCorner + 1) % 4);
        var leftCorner = algebra_1.intersects(newLeft, crossRight);
        var rightCorner = algebra_1.intersects(newRight, crossLeft);
        if (leftCorner.x && leftCorner.y) {
            moveBoxCorner(box, getCorner((corner + 1) % 4, $svg), leftCorner);
        }
        if (rightCorner.x && rightCorner.y) {
            moveBoxCorner(box, getCorner((corner + 3) % 4, $svg), rightCorner);
        }
        moveBoxCorner(box, getCorner(corner, $svg), to);
    }
    function repositionBox($svg, box, corner, to) {
        var index = parseInt($(corner).data('index'));
        switch (index) {
            case CornerIndex.topRight:
            case CornerIndex.bottomLeft:
                moveBoxCorner(box, corner, to);
                break;
            case CornerIndex.topLeft:
            case CornerIndex.bottomRight:
                shiftBoxEdges($svg, box, index, to);
                break;
        }
    }
    function resetPolygon(target, source) {
        var s = source.points;
        var tcount = target.points.numberOfItems;
        for (var i = 0; i < s.numberOfItems; i++) {
            var sp = s.getItem(i);
            if (i >= tcount) {
                var tp = new SVGPoint();
                tp.x = sp.x;
                tp.y = sp.y;
                target.points.appendItem(tp);
            }
            else {
                var tp = target.points.getItem(i);
                tp.x = sp.x;
                tp.y = sp.y;
            }
        }
        while (tcount > s.numberOfItems) {
            target.points.removeItem(tcount - 1);
            tcount = target.points.numberOfItems;
        }
    }
    exports.resetPolygon = resetPolygon;
    function resetBox(target, source) {
        resetPolygon(target, source);
        var svg = $(target).closest('svg');
        svg.find('.point-handle').each(function (i, x) {
            svg[0].removeChild(x);
        });
        markBoxCorners(svg);
        makeBoxResizable(svg, handleBoxStretch);
        syncSizeSegments(svg);
    }
    exports.resetBox = resetBox;
    function toggleWindowBox($svg, visible) {
        var svg = $svg[0];
        if (svg.classList) {
            svg.classList.toggle('hidden', !visible);
            if (visible) {
                $svg.find('[name="SizeLayer"]').each(function (i, s) { return s.classList.toggle('hidden', true); });
                $svg.find('[name="Layer"]').each(function (i, s) { return s.classList.toggle('hidden', false); });
            }
        }
        else {
            $svg.attr('class', visible ? '' : 'hidden');
        }
    }
    exports.toggleWindowBox = toggleWindowBox;
    function findFittingViewBox(polygon, defaultBox) {
        var points = polygon.points;
        var topLeft = { X: defaultBox.topLeft.X, Y: defaultBox.topLeft.Y };
        var bottomRight = { X: topLeft.X + defaultBox.size.Width, Y: topLeft.Y + defaultBox.size.Height };
        for (var i = 0; i < points.numberOfItems; i++) {
            var point = points.getItem(i);
            topLeft.X = Math.min(point.x, topLeft.X);
            topLeft.Y = Math.min(point.y, topLeft.Y);
            bottomRight.X = Math.max(point.x, bottomRight.X);
            bottomRight.Y = Math.max(point.y, bottomRight.Y);
        }
        return {
            topLeft: topLeft,
            size: {
                Width: bottomRight.X - topLeft.X,
                Height: bottomRight.Y - topLeft.Y
            }
        };
    }
    exports.findFittingViewBox = findFittingViewBox;
    function fitWindowBoxInside(svg, polygon) {
        var viewBox = svg.viewBox;
        var defaultBox = {
            topLeft: {
                X: viewBox.baseVal.x,
                Y: viewBox.baseVal.y
            },
            size: {
                Width: viewBox.baseVal.width,
                Height: viewBox.baseVal.height
            }
        };
        var fitBox = findFittingViewBox(polygon, defaultBox);
        viewBox.baseVal.x = fitBox.topLeft.X;
        viewBox.baseVal.y = fitBox.topLeft.Y;
        viewBox.baseVal.width = fitBox.size.Width;
        viewBox.baseVal.height = fitBox.size.Height;
    }
    exports.fitWindowBoxInside = fitWindowBoxInside;
    function keepInBoundingBox(point, box) {
        var minX = box.topLeft.X;
        var maxX = minX + box.size.Width;
        var minY = box.topLeft.Y;
        var maxY = minY + box.size.Height;
        if (point.X < minX) {
            console.info('snap X to minX');
        }
        return {
            X: Math.min(maxX, Math.max(minX, point.X)),
            Y: Math.min(maxY, Math.max(minY, point.Y))
        };
    }
    exports.keepInBoundingBox = keepInBoundingBox;
    function inflateBox(box, margin) {
        return {
            topLeft: {
                X: box.topLeft.X - margin.Width,
                Y: box.topLeft.Y - margin.Height
            },
            size: {
                Width: box.size.Width + 2 * margin.Width,
                Height: box.size.Height + 2 * margin.Height
            }
        };
    }
    exports.inflateBox = inflateBox;
    function handleBoxStretch(target, clientX, clientY) {
        var corner = $(target);
        var $svg = corner.closest('svg');
        var rectangular = $svg.data('rectangular');
        var svg = $svg[0];
        var box = $svg.find('polygon#window-box')[0];
        var viewBox = svg.viewBox;
        var offsetParent = $svg.closest('.img-box');
        var offsets = offsetParent.offset();
        var offsetTop = offsets.top;
        var offsetLeft = offsets.left;
        var $window = $(window);
        var scrollTop = $window.scrollTop();
        var scrollLeft = $window.scrollLeft();
        var offsetX = clientX + scrollLeft - offsetLeft;
        var offsetY = clientY + scrollTop - offsetTop;
        var offsetWidth = offsetParent.width();
        var offsetHeight = offsetParent.height();
        var offsetAspect = offsetHeight / offsetWidth;
        var boxAspect = viewBox.baseVal.height / viewBox.baseVal.width;
        var boundingBox = inflateBox({
            topLeft: { X: 0, Y: 0 },
            size: { Width: offsetWidth, Height: offsetHeight }
        }, {
            Width: 0,
            Height: 0
        });
        var boundedPoint = keepInBoundingBox({
            X: offsetX, Y: offsetY
        }, boundingBox);
        var x = boundedPoint.X * viewBox.baseVal.width / offsetWidth;
        var y = boundedPoint.Y * viewBox.baseVal.height / offsetHeight;
        if (offsetAspect < boxAspect) {
            x = boundedPoint.X * viewBox.baseVal.height / offsetHeight;
        }
        else if (offsetAspect > boxAspect) {
            y = boundedPoint.Y * viewBox.baseVal.width / offsetWidth;
        }
        if (rectangular) {
            repositionRectangularBox($svg, box, target, { x: x, y: y });
        }
        else {
            repositionBox($svg, box, target, { x: x, y: y });
        }
        $(box).resize();
        syncSizeSegments($svg);
    }
    exports.handleBoxStretch = handleBoxStretch;
    function toggleSizeMark($svg, mark, show) {
        var line = $svg.find("#" + mark + "-mark")[0];
        var sizeLayer = $svg.find('[name="SizeLayer"]')[0];
        line.classList.toggle('hidden', !show);
        var svg = $svg[0];
        if (show) {
            sizeLayer.classList.toggle('hidden', false);
            line.classList.toggle('hidden', !show);
        }
        if (svg.classList.contains('hidden') && show) {
            svg.classList.toggle('hidden', false);
            $svg.find('[name="Layer"]').each(function (i, s) { return s.classList.toggle('hidden', true); });
        }
    }
    exports.toggleSizeMark = toggleSizeMark;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/svg.js
// module id = 39
// module chunks = 0